<template>
  <div class="NewsDetails">
    <mbBanner title="新闻资讯详情" />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <p class="product-title">{{newsIdList.title}}</p>
        <p class="product-time">{{newsIdList.createTime}}</p>
        <p class="ql-editor mb-editor" v-html="newsIdList.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import mbBanner from "./mb_banner.vue";
export default {
  components: {
    mbBanner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
    // window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http.post('/oa/newcms/article/getDataByid',{id:this.pid})
      .then(response => {
      	this.newsIdList = response.data.result
      	// console.log(response)
      })
      .catch(error=> {
        
      })
    }
  }
};
</script>
<style >
	.NewsDetails-product-content .ql-editor .ql-align-center img{
		width: 100% !important;
	}
</style>
<style lang="scss" scoped>
@import '../../assets/css/vue2-editor.css';
.NewsDetails {
  width: 100%;
  height: 100%;
  
  &-product {
    width: 100%;
    margin: 0 auto;
    &-content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
	  box-sizing: border-box;
	  
      .product-title {
		width: 100%;
		text-align: center;
		font-size: 18px;
        color: #e13834;
        padding: 15px;
		box-sizing: border-box;
      }
	  .product-time{
		width: 100%;
		text-align: right;
		padding:0px 15px;
		box-sizing: border-box;
		font-size: 14px;
		color: #999999;
	  }
	  .ql-editor{
		  .ql-align-center{
			 img{
				width: 100% !important;
			 } 
		  }
	  }
    }
  }
}
</style>